import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useMediaQuery } from 'react-responsive';
import dayjs from '@/js/libs/dayjs';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Media } from '@/js/libs/ui/src/theme/Media';
import { Icons, Select } from '@/js/libs/ui/src/V2';
import { Header, MobileHeader, Preset, PresetsWrapper } from './styled';
export const TimePresets = React.memo(function TimePresets({ title = 'Time', presets, date, onChange, isDateSelected, }) {
    const isMobile = useMediaQuery({ query: Media.xsMax });
    const selectOptions = React.useMemo(() => presets.map(({ title, value }) => ({
        label: title,
        value,
    })), [presets]);
    const selectedValue = React.useMemo(() => {
        const activePreset = presets.find(({ isActive, value }) => isActive(value, date));
        return activePreset ? { label: activePreset.title, value: activePreset.value } : undefined;
    }, [date, presets]);
    const handleSelectChange = useCallbackRef((option) => {
        if (option?.value) {
            const timePresetDate = dayjs(option.value);
            const updatedValue = dayjs(date).hour(timePresetDate.hour()).minute(timePresetDate.minute());
            onChange(updatedValue.toDate());
        }
    });
    // eslint-disable-next-line no-restricted-syntax
    const createTimePresetClickHandler = React.useCallback((value) => () => {
        if (!isDateSelected) {
            return;
        }
        const timePresetDate = dayjs(value);
        const updatedValue = dayjs(date).hour(timePresetDate.hour()).minute(timePresetDate.minute());
        onChange(updatedValue.toDate());
    }, [date, isDateSelected, onChange]);
    if (!isDateSelected) {
        return null;
    }
    return (_jsx("div", { children: isMobile ? (_jsxs("div", { children: [_jsx(MobileHeader, { children: title }), _jsx(Select, { options: selectOptions, value: selectedValue, onChange: handleSelectChange, isDisabled: !isDateSelected })] })) : (_jsxs(_Fragment, { children: [_jsx(Header, { children: title }), _jsx(PresetsWrapper, { children: presets.map(({ isActive, title, value }) => {
                        const isActivePreset = isActive(value, date);
                        return (_jsxs(Preset, { onClick: createTimePresetClickHandler(value), isActive: isActivePreset, children: [title, isActivePreset && _jsx(Icons.Checkmark, { size: 20 })] }, title));
                    }) })] })) }));
});
